// 库存查询
export default {
  // 列表查询：
  GET_INVENTORY_LIST: '/warehouse/storageBusiness/queryStorageBusinessPage',
  //列表导出：
  EXPORT_INVENTORY_LIST: '/warehouse/storageBusiness/exportStorageBusiness',
  //点击单行查询库存明细：
  INVENTORY_DETAIL: '/warehouse/storageBusinessHistory/queryByList', // 传入参数所选的行的批次号batchNo=#batchNo#
  //点击单行占用明细：
  OCCUPATION_DETAIL: '/warehouse/storageBusinessOccupationDetail/queryByList', // 传入参数所选的行的批次号batchNo=#batchNo#
  //库存明细导出：
  EXPORT_INVENTORY_DETAIL: '/warehouse/storageBusinessHistory/exportStorageBusinessHistory', //传入参数所选的行的批次号batchNo=#batchNo#
  //占用明细导出：
  EXPORT_OCCUPATION_DETAIL:
    '/warehouse/storageBusinessOccupationDetail/exportStorageBusinessOccupationDetail', //传入参数所选的行的批次号batchNo=#batchNo#
  // 选择库存批次生成成本调整单
  CREATE_COST_ADJUST: '/warehouse/costAdjustOrder/createCostAdjust', //  传参List<Long> ids ，即选中的库存批次的id集合',
};
